
angular.module('sodNotificationCenter', ['ngLodash', 'ActionManager', 'ResourceGenerator']);